export default __webpack_public_path__ + "static/media/arrow-orange.ef0bba9d.svg";